import Colors from '@rockalingua/ui/constants/Colors';
import { staticCdnHost } from '@rockalingua/ui/constants/Cdn';

import Text from '../Typography/Text';

import {
  Container,
  SchoolImage,
  SchoolImageContainer,
  SchoolItem,
  SchoolTexts,
} from './SchoolIcons.styled';

type School = {
  title: string;
  description: string;
  image: string;
};

const schools: School[] = [
  {
    title: 'French American School',
    description: 'New York, USA',
    image: '/img/home/fasny.svg',
  },
  {
    title: 'Salusbury Primary School',
    description: 'London, UK',
    image: '/img/home/salusbury.png',
  },
  {
    title: 'Marin Country Day School',
    description: 'San Francisco, USA',
    image: '/img/home/marin.svg',
  },
  {
    title: 'Aitken Creek Primary School',
    description: 'Victoria, Australia',
    image: '/img/home/aitken.png',
  },
];

export default function SchoolIcons() {
  return (
    <Container>
      {schools.map((school) => (
        <SchoolItem key={school.title}>
          <SchoolImageContainer>
            <SchoolImage
              src={staticCdnHost + school.image}
              alt={school.title}
              loading="lazy"
            />
          </SchoolImageContainer>
          <SchoolTexts>
            <Text variant="cardTitle" color={Colors.NEUTRAL_VARIANTS[100]}>
              {school.title}
            </Text>
            <Text variant="grey-16-bold" color={Colors.NEUTRAL_VARIANTS[80]}>
              {school.description}
            </Text>
          </SchoolTexts>
        </SchoolItem>
      ))}
    </Container>
  );
}
